import _toConsumableArray from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _taggedTemplateLiteral from "/builds/mfresearchtool/mfresearchtool-ui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
import { Ge as S, hi as k, di as b, w as f, bo as m, M as g } from "./abstract-base-8edf0a84-e11d45a3.js";
import { i as T } from "./query-24926cff-3eb94bfb.js";
import { e as D } from "./map-7910a3a7-389c4b7b.js";
import { _t as O, St as w } from "./chart-base-ecca78b9-a6ec3103.js";
import { p as c } from "./chart-base.helpers-722f3948-fa82acec.js";
import { o as R } from "./scale-8b395353-27d44d00.js";
import { r as V } from "./utils-2e24a437-383bbd0f.js";
import { o as v } from "./chart-tooltip.constants-f76f46e6-1f185240.js";
import "./breakpoints-1ea07f11-d0da757c.js";
import "./unsafe-svg-8b07bc77-f986d223.js";
import "./variables-37cba309-153935bd.js";
import "./state-b4c9cc73-ee633f6c.js";
import "./chart-tooltip-e4995844-42c7681e.js";
import "./legend-5216905c-c7014324.js";
import "./legend-circle-0e9cbc84-7a23b644.js";
import "./directive-daf4e9b6-abc0af54.js";
var u = /* @__PURE__ */function (s) {
    return s.DEFAULT = "default", s.TARGET = "target", s.SUBDIVIDED = "subdivided", s;
  }(u || {}),
  h = /* @__PURE__ */function (s) {
    return s.NORMAL = "normal", s.TINTED = "tinted", s.FUNCTIONAL = "functional", s;
  }(h || {});
var n = {
    beaconTagName: "beacon-gauge-chart",
    tooltipID: "chart-custom-tooltip",
    attribute: {
      name: "name",
      value: "value",
      valueSuffix: "value-suffix",
      valuePrefix: "value-prefix",
      metricDescription: "metric-description",
      gaugeTarget: "target",
      targetRange: "target-range",
      gaugeMin: "min",
      gaugeMax: "max",
      metricScale: "metric-scale",
      colorType: "color-type",
      hideMetric: "hide-metric",
      disableSort: "disable-sort",
      gaugeLabels: "gauge-labels",
      subdividedBands: "subdivided-bands"
    },
    samples: {
      bands: [["Target A", 5], ["Target B", 10], ["Target C", 15], ["Target D", 20]]
    }
  },
  y = function y(s) {
    return s.toFixed(2).replace(/\.00/, "");
  },
  C = S(_templateObject || (_templateObject = _taggedTemplateLiteral([".highcharts-grid-line{stroke:var(--beacon-chart-color-background)}.highcharts-dial,.highcharts-pivot,.highcharts-minor-grid-line,.highcharts-plot-lines-10,figure.hide-grid>.highcharts-grid-line{display:none}.gauge-value,.gauge-background,.gauge-target{cursor:pointer;fill-opacity:100%}.gauge-tint-100{fill:var(--beacon-gauge-chart-tinted-gauge-color-fill-100)}.gauge-tint-legend-100{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-tinted-gauge-color-fill-100)}.gauge-tint-200{fill:var(--beacon-gauge-chart-tinted-gauge-color-fill-200)}.gauge-tint-legend-200{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-tinted-gauge-color-fill-200)}.gauge-tint-300{fill:var(--beacon-gauge-chart-tinted-gauge-color-fill-300)}.gauge-tint-legend-300{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-tinted-gauge-color-fill-300)}.gauge-tint-400{fill:var(--beacon-gauge-chart-tinted-gauge-color-fill-400)}.gauge-tint-legend-400{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-tinted-gauge-color-fill-400)}.gauge-tint-500{fill:var(--beacon-gauge-chart-tinted-gauge-color-fill-500)}.gauge-tint-legend-500{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-tinted-gauge-color-fill-500)}.gauge-functional-100{fill:var(--beacon-gauge-chart-functional-gauge-color-fill-100)}.gauge-functional-legend-100{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-functional-gauge-color-fill-100)}.gauge-functional-200{fill:var(--beacon-gauge-chart-functional-gauge-color-fill-200)}.gauge-functional-legend-200{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-functional-gauge-color-fill-200)}.gauge-functional-300{fill:var(--beacon-gauge-chart-functional-gauge-color-fill-300)}.gauge-functional-legend-300{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-functional-gauge-color-fill-300)}.gauge-functional-400{fill:var(--beacon-gauge-chart-functional-gauge-color-fill-400)}.gauge-functional-legend-400{--beacon-chart-override-drilldown-series-color-0: var(--beacon-gauge-chart-functional-gauge-color-fill-400)}.gauge-target{fill:var(--beacon-color-border-tertiary)}.gauge-background{fill:var(--beacon-gauge-chart-color-background)}.highcharts-axis-labels{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-caption-300, var(--beacon-caption-font-size-300)/var(--beacon-caption-font-line-height-module-300) var(--beacon-font-family-default))}.key-fact{text-align:center;transform:translateY(calc(-1 * var(--key-fact-transform)))}.key-fact .key-fact-main{font-size:var(--key-fact-font);font-weight:var(--beacon-font-weight-bold)}.key-fact.mini{--key-fact-transform: var(--beacon-gauge-chart-metric-font-size-mini);--key-fact-font: var(--beacon-gauge-chart-metric-font-size-mini)}.key-fact.normal{--key-fact-transform: var(--beacon-gauge-chart-metric-font-size-normal);--key-fact-font: var(--beacon-gauge-chart-metric-font-size-normal)}.key-fact.jumbo{--key-fact-transform: var(--beacon-gauge-chart-metric-font-size-jumbo);--key-fact-font: var(--beacon-gauge-chart-metric-font-size-jumbo)}.key-fact-description{font:var(--beacon-system-font-weight-normal, var(--beacon-font-weight-normal)) var(--beacon-system-font-size-sans-serif-headline-100, var(--beacon-headline-font-size-100)/var(--beacon-headline-font-line-height-module-100) var(--beacon-font-family-default))}\n"])));
var A = Object.defineProperty,
  E = Object.getOwnPropertyDescriptor,
  o = function o(s, e, t, a) {
    for (var r = a > 1 ? void 0 : a ? E(e, t) : e, l = s.length - 1, d; l >= 0; l--) (d = s[l]) && (r = (a ? d(e, t, r) : d(r)) || r);
    return a && r && A(e, t, r), r;
  };
var M = n.beaconTagName;
var i = /*#__PURE__*/function (_k) {
  _inherits(i, _k);
  function i() {
    var _this;
    _classCallCheck(this, i);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(i).apply(this, arguments)), _this.beaconTagName = M, _this.gaugeName = "Default", _this.gaugeValueProp = 0, _this.valueSuffix = "", _this.valuePrefix = "", _this.metricDescription = "", _this.gaugeTarget = 0, _this.targetRange = 0, _this.gaugeMin = 0, _this.gaugeMax = 100, _this.variant = u.DEFAULT, _this.metricScale = R.NORMAL, _this.colorType = h.NORMAL, _this.percentage = !1, _this.hideMetric = !1, _this.disableSort = !1, _this.gaugeLabels = [], _this.subdividedBandsProp = [], _this.resizeObserver = new ResizeObserver(V(function () {
      _this.chart && _this.renderMetric(_this.chart);
    }, 100));
    return _this;
  }
  _createClass(i, [{
    key: "plotBandObject",
    /**
     * Helper function to define gauge plot bands
     *
     * TODO: Add tooltip interaction in this function
     * @param from start of plot band
     * @param to end of plot band
     * @param className CSS class name applied to plot band
     * @param label to name the band
     * @returns object of plot band with tooltip data and positioning logic
     */
    value: function plotBandObject(e, t, a, r) {
      var l = this.tooltipRef,
        d = this.figure,
        L = this.subdividedBands,
        $ = this.variant;
      return {
        from: e,
        to: t,
        className: a,
        label: r,
        thickness: "20%",
        events: {
          mouseover: function mouseover(x) {
            var N = this.svgElem.element.getBoundingClientRect();
            var p = 0;
            $ === u.SUBDIVIDED && L.forEach(function (B, I) {
              r === B[0] && (p = I), l.tooltipData = [{
                label: r,
                value: t - e,
                index: p
              }];
            }), l.tooltipData = [{
              label: r,
              value: t - e,
              index: p
            }], l.targetRect = N, l.viewportRect = d.getBoundingClientRect(), l.isOpen = !0;
          },
          mouseout: function mouseout(x) {
            l.isOpen = !1;
          }
        }
      };
    }
    /**
     * Logic to identify which plot bands are applied based on the gauge
     *
     * @returns plot band array for single color gauge
     */
  }, {
    key: "singleColorMode",
    value: function singleColorMode() {
      var _this2 = this;
      var e = [],
        t = function t(a) {
          return _this2.plotBandObject(_this2.gaugeMin, _this2.gaugeValue, a, _this2.gaugeName);
        };
      switch (this.variant === u.TARGET && (this.targetRange > 0 ? e.push(this.plotBandObject(this.gaugeTarget, this.gaugeTarget + this.targetRange, "gauge-target", this.gaugeName)) : e.push(this.plotBandObject(this.gaugeValue, this.gaugeTarget, "gauge-target", this.gaugeName))), this.colorType) {
        case h.NORMAL:
          e.push(t("gauge-value highcharts-color-0"));
          break;
        case h.TINTED:
          e.push(t("gauge-value gauge-tint-".concat(this.tintIndex, "00")));
          break;
        case h.FUNCTIONAL:
          e.push(t("gauge-value gauge-functional-".concat(this.tintIndex, "00")));
          break;
        default:
          e.push(t("gauge-value highcharts-color-0"));
          break;
      }
      return e;
    }
    /**
     * Logic to identify which plot bands are applied based on the gauge
     *
     * @returns plot band array for subdivided color gauge
     */
  }, {
    key: "subdividedColorMode",
    value: function subdividedColorMode() {
      var e = [];
      var t = this.gaugeMin;
      for (var a in this.subdividedBands) {
        var r = this.subdividedBands[a];
        e.push(this.plotBandObject(t, t + r[1], "gauge-value highcharts-color-".concat(a), r[0])), t += r[1];
      }
      return e;
    }
    /**
     * Renders the metric based on the center of the chart
     *
     * @param chart Highcharts chart
     */
  }, {
    key: "renderMetric",
    value: function renderMetric(e) {
      if (e) if (this.hideMetric) e.metricHTML.css({
        display: "none"
      });else {
        var _this$chartCenter = this.chartCenter,
          t = _this$chartCenter.x,
          a = _this$chartCenter.y,
          r = a + 4;
        e.metricHTML ? e.metricHTML.attr({
          text: this.metricHTML,
          x: t,
          y: r
        }).css({
          display: "initial"
        }) : e.metricHTML = e.renderer.html(this.metricHTML, t, r).attr({
          align: "center"
        }).add();
      }
    }
    /**
     * Chart redraw lifecycle hook to render metric
     *
     * @param chart Highcharts chart
     */
  }, {
    key: "onChartRedraw",
    value: function onChartRedraw(e) {
      this.renderMetric(e);
    }
    /**
     * Chart load lifecycle hook to render metric
     *
     * @param chart Highcharts chart
     */
  }, {
    key: "onChartLoad",
    value: function onChartLoad(e) {
      _get(_getPrototypeOf(i.prototype), "onChartLoad", this).call(this, e), this.renderMetric(e), this.staticLegend = !0;
    }
    /**
     * First updated lifecycle hook that sets the resize observer
     *
     * @returns super call to first updated
     */
  }, {
    key: "firstUpdated",
    value: function () {
      var _firstUpdated = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", (this.resizeObserver.observe(this), _get(_getPrototypeOf(i.prototype), "firstUpdated", this).call(this)));
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function firstUpdated() {
        return _firstUpdated.apply(this, arguments);
      }
      return firstUpdated;
    }()
    /**
     * Conditionally renders
     */
  }, {
    key: "renderLegendItems",
    value: function renderLegendItems() {
      var _this3 = this;
      return this.variant === u.SUBDIVIDED ? b(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["<", " class=\"legend\" direction=", " visible-items=", " ?is-static=", ">\n      ", "\n        </", ">"])), this.getScopedTag(c.beaconLegendName), this.legendLayout.direction, this.visibleLegendItems, this.staticLegend, D(this.subdividedBands, function (e, t) {
        return b(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["<", " data-legend-item=\"primary\" label=", " index=", " value=", "></", ">"])), _this3.getScopedTag(c.beaconLegendItemName), e[0], t, _this3.hideLegendMetric ? f : e[1], _this3.getScopedTag(c.beaconLegendItemName));
      }), this.getScopedTag(c.beaconLegendName)) : b(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["<", " class=\"legend ", "\" direction=", " visible-items=", " ?is-static=", ">\n    ", "\n    </", ">"])), this.getScopedTag(c.beaconLegendName), this.legendColor, this.legendLayout.direction, this.visibleLegendItems, this.staticLegend, b(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["<", " data-legend-item=\"primary\" label=", " value=", "></", ">"])), this.getScopedTag(c.beaconLegendItemName), this.gaugeName, this.hideLegendMetric ? f : this.gaugeValueString, this.getScopedTag(c.beaconLegendItemName)), this.getScopedTag(c.beaconLegendName));
    }
    /**
     * Returns legend HTML template string
     */
  }, {
    key: "renderLegend",
    value: function renderLegend() {
      return m(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["<div id=\"legend\" class=\"legend-container\">", "</div>"])), this.renderLegendItems());
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      return b(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    <", " id=", "></", ">"])), this.getScopedTag("".concat(v.beaconTagName)), n.tooltipID, this.getScopedTag("".concat(v.beaconTagName)));
    }
    /**
     * Overrides chart-base render function
     *
     * @returns HTML template for gauge chart
     */
  }, {
    key: "render",
    value: function render() {
      return m(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["<figure\n      class=\"chart-and-tooltip-wrapper base ", "\"\n      data-layout-vertical=\"", "\"\n      data-layout-horizontal=\"", "\"\n    >\n      <div id=\"container\" class=\"chart chart--", "\"></div>\n      ", "\n      <div id=\"tooltip-container\" class=\"chart chart--", "\"></div>\n      ", "\n    </figure>"])), this.gaugeLabels.length > 3 ? "hide-grid" : "", this.legendLayout.vertical, this.legendLayout.horizontal, this.type, this.renderLegend(), this.type, this.renderTooltip());
    }
  }, {
    key: "type",
    /**
     * Set ChartType to Gauge
     */
    get: function get() {
      return O.GAUGE;
    }
    /**
     * Override chart base to disable table
     */
  }, {
    key: "exportMenuItems",
    get: function get() {
      return c.exportMenuItems;
    }
    /**
     * Sets the gauge value to the sum of the subdivided bands otherwise returns what is passed via the prop
     */
  }, {
    key: "gaugeValue",
    get: function get() {
      var e = 0;
      return this.variant === u.SUBDIVIDED ? e = this.subdividedBands.reduce(function (t, a) {
        return t + a[1];
      }, 0) : e = this.gaugeValueProp, e <= this.gaugeMax && e >= this.gaugeMin ? e : e > this.gaugeMax ? (console.error("Gauge value too large"), this.gaugeMax) : (console.error("Gauge value too small"), this.gaugeMin);
    }
    /**
     * Returns display string for gauge value based on props provided
     */
  }, {
    key: "gaugeValueString",
    get: function get() {
      var e = this.gaugeValue;
      return this.percentage ? (this.variant === u.TARGET && this.targetRange <= 0 && (e = this.gaugeValue / (this.gaugeTarget - this.gaugeMin) * 100), e = this.gaugeValue / (this.gaugeMax - this.gaugeMin) * 100, "".concat(y(e), "%")) : "".concat(this.valuePrefix).concat(y(this.gaugeValue)).concat(this.valueSuffix);
    }
    /**
     * Calculates the interval between ticks based on the number of sections
     */
  }, {
    key: "tickInterval",
    get: function get() {
      return (this.gaugeMax - this.gaugeMin) / this.labelSections;
    }
    /**
     * Auto-sorts subdivided bands unless disableSort prop is set
     */
  }, {
    key: "subdividedBands",
    get: function get() {
      return this.disableSort ? this.subdividedBandsProp : _toConsumableArray(this.subdividedBandsProp).sort(function (e, t) {
        return t[1] - e[1];
      });
    }
    /**
     * Returns padded label array for Highcharts API
     */
  }, {
    key: "labels",
    get: function get() {
      return [""].concat(_toConsumableArray(this.gaugeLabels), [""]);
    } /** Returns legend color based on color type */
  }, {
    key: "legendColor",
    get: function get() {
      return this.colorType === h.TINTED ? "gauge-tint-legend-".concat(this.tintIndex, "00") : this.colorType === h.FUNCTIONAL ? "gauge-functional-legend-".concat(this.tintIndex, "00") : "";
    }
    /**
     * Set plot bands based on variant and band values
     */
  }, {
    key: "plotBands",
    get: function get() {
      var e = [this.plotBandObject(this.gaugeMin, this.gaugeMax, "gauge-background", this.gaugeName)];
      return this.variant !== u.SUBDIVIDED ? e.push.apply(e, _toConsumableArray(this.singleColorMode())) : e.push.apply(e, _toConsumableArray(this.subdividedColorMode())), e;
    }
    /**
     * Sets a tint based on the relative value of the gauge
     */
  }, {
    key: "tintIndex",
    get: function get() {
      var e;
      this.variant === u.TARGET && this.gaugeTarget > this.gaugeValue ? e = (this.gaugeTarget - this.gaugeMin) / this.sections : e = (this.gaugeMax - this.gaugeMin) / this.sections;
      var t = Math.ceil((this.gaugeValue - this.gaugeMin) / e);
      return t > 4 ? 4 : t;
    }
    /**
     * Returns the number of sections based on gauge variant
     */
  }, {
    key: "sections",
    get: function get() {
      return this.colorType === h.FUNCTIONAL ? 4 : 5;
    }
    /**
     * Sets text labels sections when provided
     */
  }, {
    key: "labelSections",
    get: function get() {
      return this.gaugeLabels.length ? this.gaugeLabels.length + 1 : this.sections;
    }
    /**
     * Queries the plot band SVG element to find the center of the chart
     */
  }, {
    key: "chartCenter",
    get: function get() {
      var e;
      var t = (e = this.shadowRoot) == null ? void 0 : e.querySelector(".highcharts-plot-bands-0");
      if (!t) return {
        x: 0,
        y: 0
      };
      var a = t.getBBox();
      return {
        x: a.x + a.width / 2,
        y: a.y + a.height
      };
    }
    /**
     * Template string of the metric placed in the center of the chart
     */
  }, {
    key: "metricHTML",
    get: function get() {
      return "<div class=\"key-fact ".concat(this.metricScale, "\">\n    <div class=\"key-fact-main\">").concat(this.gaugeValueString, "</div>\n    ").concat(this.metricDescription ? "<div class=\"key-fact-description\">".concat(this.metricDescription, "</div>") : "", "\n    </div>");
    }
    /**
     * Gauge specific component Highcharts API options
     */
  }, {
    key: "localComponentOptions",
    get: function get() {
      var _this4 = this;
      return {
        chart: {
          plotBackgroundColor: null,
          plotBackgroundImage: null,
          plotBorderWidth: 0
        },
        series: [{
          data: [this.gaugeValue],
          dataLabels: {
            enabled: !1
          }
        }],
        pane: {
          startAngle: -90,
          endAngle: 90,
          background: null,
          center: ["50%", "66%"]
        },
        yAxis: {
          min: this.gaugeMin,
          max: this.gaugeMax,
          labels: {
            distance: 12,
            formatter: this.gaugeLabels.length > 0 ? function (e) {
              var t = Math.round(e.pos / _this4.tickInterval);
              return _this4.labels[t];
            } : void 0
          },
          plotBands: this.plotBands,
          tickInterval: this.tickInterval
        }
      };
    }
  }], [{
    key: "styles",
    get: function get() {
      return [_get(_getPrototypeOf(i), "styles", this), C];
    }
  }]);
  return i;
}(k(w));
i.tagName = M;
o([g({
  attribute: n.attribute.name
})], i.prototype, "gaugeName", 2);
o([g({
  attribute: n.attribute.value,
  type: Number
})], i.prototype, "gaugeValueProp", 2);
o([g({
  attribute: n.attribute.valueSuffix
})], i.prototype, "valueSuffix", 2);
o([g({
  attribute: n.attribute.valuePrefix
})], i.prototype, "valuePrefix", 2);
o([g({
  attribute: n.attribute.metricDescription
})], i.prototype, "metricDescription", 2);
o([g({
  attribute: n.attribute.gaugeTarget,
  type: Number
})], i.prototype, "gaugeTarget", 2);
o([g({
  attribute: n.attribute.targetRange,
  type: Number
})], i.prototype, "targetRange", 2);
o([g({
  attribute: n.attribute.gaugeMin,
  type: Number
})], i.prototype, "gaugeMin", 2);
o([g({
  attribute: n.attribute.gaugeMax,
  type: Number
})], i.prototype, "gaugeMax", 2);
o([g()], i.prototype, "variant", 2);
o([g({
  attribute: n.attribute.metricScale
})], i.prototype, "metricScale", 2);
o([g({
  attribute: n.attribute.colorType
})], i.prototype, "colorType", 2);
o([g({
  type: Boolean
})], i.prototype, "percentage", 2);
o([g({
  type: Boolean,
  attribute: n.attribute.hideMetric
})], i.prototype, "hideMetric", 2);
o([g({
  type: Boolean,
  attribute: n.attribute.disableSort
})], i.prototype, "disableSort", 2);
o([g({
  attribute: n.attribute.gaugeLabels,
  type: Object
})], i.prototype, "gaugeLabels", 2);
o([g({
  attribute: n.attribute.subdividedBands,
  type: Object
})], i.prototype, "subdividedBandsProp", 2);
o([T("#chart-custom-tooltip")], i.prototype, "tooltipRef", 2);
o([T("figure.base")], i.prototype, "figure", 2);
export { i as BeaconGaugeChart };